import { ReactNode } from "react";
import cx from "classnames";

import Box, { BoxProps } from "../Box";
import styles from "./styles.module.css";

type DrawerFooterProps = {
  children: ReactNode;
} & BoxProps;

const DrawerFooter = ({ children, className, ...boxProps }: DrawerFooterProps) => {
  return (
    <Box
      direction="row"
      justify="end"
      align="center"
      className={cx(styles.footer, className)}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

DrawerFooter.displayName = "DS.Drawer.Footer";

export default DrawerFooter;
